import { InvoiceItem } from "../../GeneratedClients/FreeBillApi";
import ItemCalculator from "./item/ItemCalculator";

class Invoice{
  items
  constructor(items?: InvoiceItem[]){
    this.items = items
  }

  getGrossAmount() {
    return this.calculateGrossAmount(this.items)
  }

  getNetAmount() {
    return this.calculateNetAmount(this.items)
  }

  getTaxAmount() {
    return this.calculateTaxAmount(this.items)
  }

  getTaxAmounts() {
    const itemsWith19PercentTax = this.items ? this.items.filter(x => x.tax_in_percent === 0.19) : []
    const itemsWith16PercentTax = this.items ? this.items.filter(x => x.tax_in_percent === 0.16) : []
    const itemsWith7PercentTax = this.items ? this.items.filter(x => x.tax_in_percent === 0.07) : []
    const itemsWith5PercentTax = this.items ? this.items.filter(x => x.tax_in_percent === 0.05) : []
    const itemsWithoutTax = this.items ? this.items.filter(x => x.tax_in_percent === 0.0) : []

    const taxAmounts = [
      {name: "19 %", isDisplayed: itemsWith19PercentTax.length > 0, amount: this.calculateTaxAmount(itemsWith19PercentTax) },
      {name: "16 %", isDisplayed: itemsWith16PercentTax.length > 0, amount: this.calculateTaxAmount(itemsWith16PercentTax)},
      {name: "7 %", isDisplayed: itemsWith7PercentTax.length > 0, amount: this.calculateTaxAmount(itemsWith7PercentTax)},
      {name: "5 %", isDisplayed: itemsWith5PercentTax.length > 0, amount: this.calculateTaxAmount(itemsWith5PercentTax)},
      {name: "0 %", isDisplayed: false, amount: this.calculateTaxAmount(itemsWithoutTax)},
    ]
    return taxAmounts
  }

  private calculateGrossAmount = (items?: InvoiceItem[]) => {
    let sum = 0
    const numArray: number[] = items ? (
      items.map((item: InvoiceItem) => {
        const itemCalculator = new ItemCalculator(item)
        return itemCalculator.getGrossAmount()
      })
    ) : (
      []
    )
    numArray.forEach( (num: number) => {sum += num})
    return sum
  }

  private calculateNetAmount = (items?: InvoiceItem[]) => {
    let sum = 0
    const numArray: number[] = items ? (
      items.map((item: InvoiceItem) => {
        const itemCalculator = new ItemCalculator(item)
        return itemCalculator.getNetAmount()
      })
    ) : (
      []
    )
    numArray.forEach( (num: number) => {sum += num})
    return sum
  }

  private calculateTaxAmount = (items?: InvoiceItem[]) => {
    let sum = 0
    const numArray: number[] = items ? (
      items.map((item: InvoiceItem) => {
        const itemCalculator = new ItemCalculator(item)
        return itemCalculator.getTaxAmount()
      })
    ) : (
      []
    )
    numArray.forEach( (num: number) => {sum += num})
    return sum
  }
}

export default Invoice